import { Text, Image, Box, BoxProps } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'

import LogoIcon from '../../assets/LOGO.svg'
import PSkeleton from '../Skeleton'
import { useLanguagePath } from '../../hooks/useI18nRoute'
import { useCallback } from 'react'

const LogoBeta = ({
  srcLogo = LogoIcon,
  isLoading = false,
  isClickable = true,
  ...props
}: {
  srcLogo?: string
  isLoading?: boolean
  isClickable?: boolean
} & BoxProps) => {
  const navigate = useNavigate()
  const getPath = useLanguagePath()

  const onClick = useCallback(() => {
    if (!isClickable) return
    navigate(getPath('/'))
  }, [isClickable, navigate, getPath])
  return (
    <PSkeleton
      isLoaded={!isLoading}
      maxW={'206px!important'}
      maxH={'60px!important'}
      opacity={isLoading ? 0.2 : 1}
      transition="opacity 0.3s ease"
      display={'flex'}
      alignItems={'center'}
      position={'relative'}
      {...props}
      className="logo-beta"
    >
      <Box
        fontSize="xl"
        fontWeight="bold"
        onClick={onClick}
        cursor={isClickable ? 'pointer' : 'auto'}
      >
        <Image src={srcLogo} objectFit="contain" aspectRatio={206 / 60} />
      </Box>

      {/* <Text
        textTransform={'uppercase'}
        fontSize="7px"
        position={'absolute'}
        top={-2}
        right={-2}
        color={colors.colorB2}
        px="10px"
        py="1px"
        border={`1px solid ${colors.colorB4}`}
      >
        Beta
      </Text> */}
    </PSkeleton>
  )
}

export default LogoBeta
